import React from 'react';
import PropTypes from 'prop-types';
import { Space, Spin } from 'antd';
import { SectionLabel, HeadquarterButton } from '../styles';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';

const HeadquarterSelector = ({ headquarters, isLoading, selectedHeadquarter, onSelect }) => {
  const { translate: t } = useDictionaryTranslation();

  return (
    <Spin spinning={isLoading}>
      <SectionLabel>{t('checkinSelectHeadquarter')}</SectionLabel>
      <Space wrap style={{ marginBottom: 16 }}>
        {headquarters.map((headquarter) => {
          const isSelected = selectedHeadquarter != null && selectedHeadquarter._id === headquarter._id;
          return (
            <HeadquarterButton
              key={headquarter._id}
              shape="round"
              $selected={isSelected}
              onClick={() => onSelect(headquarter)}
            >
              {headquarter.name}
            </HeadquarterButton>
          );
        })}
      </Space>
    </Spin>
  );
};

HeadquarterSelector.propTypes = {
  headquarters: PropTypes.array,
  isLoading: PropTypes.bool,
  selectedHeadquarter: PropTypes.object,
  onSelect: PropTypes.func,
};

export { HeadquarterSelector };
